import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';

const OAuthCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const handle = async () => {
      if (!token) {
        navigate('/login?oauth=failed');
        return;
      }
      try {
        // Save token then fetch profile
        localStorage.setItem('token', token);
        const res = await authAPI.getProfile();
        const user = res?.data?.user;
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
          // Require phone: if missing, send to profile to complete
          if (!user.phone) {
            window.location.replace('/profile?complete=phone');
            return;
          }
          
          // Route based on account type
          const accountType = user.accountType || 'farmer';
          switch (accountType) {
            case 'supplier':
              window.location.replace('/supplier/dashboard');
              return;
            case 'client':
              window.location.replace('/client/dashboard');
              return;
            default:
              window.location.replace('/dashboard');
              return;
          }
        }
        window.location.replace('/dashboard');
      } catch (e) {
        console.error('OAuth finalize error', e);
        window.location.replace('/login?oauth=failed');
      }
    };
    handle();
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-600">Signing you in…</div>
  );
};

export default OAuthCallback;


